/* zd-pdp.js - behaviour for sections/zd-main-product.liquid (Phase 2).
   One state function renders every price on the page (tier cards, main price, sticky bar) from the
   selected tier + Auto-Refill checkbox, so unticking changes all of them at once (INTENT §1).
   Add to cart goes through window.ZDCart (assets/zd-cart.js) and opens the drawer; without it the
   form posts natively. */
(function () {
  'use strict';
  var params = new URLSearchParams(window.location.search);

  function money(cents, format) {
    var a = (Number(cents) || 0) / 100;
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(a).toLocaleString('en-US');
      if (k.indexOf('comma') > -1) return a.toFixed(2).replace('.', ',');
      return a.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  // Merchant-only notes and [placeholder] text: visible with ?zdpreview=1 (Liquid cannot read the query).
  function revealMerchant() {
    if (params.get('zdpreview') !== '1') return;
    document.querySelectorAll('[data-zd-merchant]').forEach(function (el) { el.hidden = false; });
  }

  function init(root) {
    if (root.__zdInit) return;
    root.__zdInit = true;
    var fmt = root.getAttribute('data-money-format');
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    /* gallery */
    var track = $('[data-zd-track]'), thumbs = $$('[data-zd-thumb]');
    function cur() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
    function go(i) { if (!track) return; var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    var pv = $('[data-zd-prev]'), nx = $('[data-zd-next]');
    if (pv) pv.addEventListener('click', function () { go(cur() - 1); });
    if (nx) nx.addEventListener('click', function () { go(cur() + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-zd-thumb')); }); });
    if (track) track.addEventListener('scroll', function () { var c = cur(); thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === c); }); }, { passive: true });

    /* offer state */
    var tiers = $$('[data-zd-tier]'), sub = $('[data-zd-sub]');
    var form = $('[data-zd-form]');
    var idI = $('[data-zd-id]'), qI = $('[data-zd-qty]'), pI = $('[data-zd-plan]');
    var priceEl = $('[data-zd-price]'), cmpEl = $('[data-zd-compare]'), badge = $('[data-zd-badge]');
    var sp = $('[data-zd-sprice]'), sc = $('[data-zd-scompare]'), stitle = $('[data-zd-stitle]');
    var saveEl = $('[data-zd-save]'), ssaveEl = $('[data-zd-ssave]');
    var onceBtn = $('[data-zd-once]'), oncePrice = $('[data-zd-once-price]'), freqSel = $('[data-zd-freq]'), shipPerk = $('[data-zd-perk-ship]'), subT = $('[data-zd-sub-t]');
    var fsMin = +(root.getAttribute('data-fs-min') || 0);
    var refillSel = $('[data-zd-refill]');
    // Round 4: Auto-Refill / One-time are one radio-style pair (data-zd-radio), each row shows its own price; refill
    // cadence can be pills (buttons with data-value) instead of a <select>; trust line shows "Free US shipping" when it applies.
    var refillPills = refillSel ? Array.prototype.slice.call(refillSel.querySelectorAll('[data-value]')) : [];
    var subPrice = $('[data-zd-sub-price]'), markupEl = $('[data-zd-once-markup]'), markupRow = $('[data-zd-once-markup-row]'), trustShip = $('[data-zd-trust-ship]');
    function pickRefill(v) { refillPills.forEach(function (b) { var on = b.getAttribute('data-value') === v; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); }); }

    function months(txt) { var m = String(txt || '').toLowerCase().match(/(\d+)?\s*month/); return m ? (+m[1] || 1) : 0; }
    // "id|name options~..." from the Liquid; the plan whose name or option says the same number of months, else the first plan.
    function planFor(refill) {
      var want = months(refill), list = (sub.getAttribute('data-plans') || '').split('~').filter(Boolean), first = '';
      for (var i = 0; i < list.length; i++) { var bar = list[i].indexOf('|'), id = list[i].slice(0, bar); if (!first) first = id; if (want && months(list[i].slice(bar + 1)) === want) return id; }
      return first;
    }
    function subOn() { return !!(sub && sub.classList.contains('is-on')); }
    // Round 2: the struck figure is always the tier's VALUE (units x retail + gift values, from offer-pricing.json
    // through the tier block); Save % = 1 - price / value. Per-unit = price / units.
    function numbers(t) {
      var once = +t.getAttribute('data-once'), subP = t.getAttribute('data-sub'), value = +t.getAttribute('data-value');
      var units = +t.getAttribute('data-units') || 1;
      var price = once, plan = false;
      if (subOn() && subP !== '') { price = +subP; plan = true; }
      var strike = value > price ? value : 0;
      var save = strike ? Math.round(((strike - price) / strike) * 100) : 0;
      return { price: price, strike: strike, plan: plan, save: save, unit: Math.round(price / units), unitName: t.getAttribute('data-unit') || 'unit' };
    }
    function showSave(el, n) { if (!el) return; el.textContent = 'Save ' + n.save + '%'; el.hidden = !(n.save > 0); }
    function selected() { return root.querySelector('[data-zd-tier].is-on') || tiers[0]; }
    function state() {
      var t = selected();
      if (!t) return;
      tiers.forEach(function (o) {
        var n = numbers(o);
        o.querySelector('[data-zd-tp]').textContent = money(n.price, fmt);
        o.querySelector('[data-zd-tc]').textContent = n.strike > n.price ? money(n.strike, fmt) : '';
        var u = o.querySelector('[data-zd-tunit]'); if (u) u.textContent = money(n.unit, fmt) + ' / ' + n.unitName;
        showSave(o.querySelector('[data-zd-tsave]'), n);
        var on = o === t;
        o.classList.toggle('is-on', on);
        var r = o.querySelector('input'); if (r) r.checked = on;
      });
      var n = numbers(t);
      var plan = n.plan && sub && sub.getAttribute('data-plan');
      if (idI) idI.value = t.getAttribute('data-variant');
      if (qI) qI.value = t.getAttribute('data-qty');
      if (pI) { pI.disabled = !plan; pI.value = plan || ''; }
      var p = money(n.price, fmt), s = n.strike > n.price ? money(n.strike, fmt) : '';
      if (priceEl) priceEl.textContent = p;
      if (cmpEl) cmpEl.textContent = s;
      if (sp) sp.textContent = p;
      if (sc) sc.textContent = s;
      showSave(saveEl, n); showSave(ssaveEl, n);
      if (refillSel) { var rd = t.getAttribute('data-refill'); if (rd && !refillSel.__zdTouched) { if (refillPills.length) pickRefill(rd); else refillSel.value = rd; } }
      var subP2 = t.getAttribute('data-sub'), once2 = +t.getAttribute('data-once');
      if (subPrice) subPrice.textContent = money(subP2 !== '' ? +subP2 : once2, fmt);
      if (markupEl) { var mk = subP2 !== '' && +subP2 > 0 && once2 > +subP2 ? Math.round(((once2 - +subP2) / +subP2) * 100) : 0; markupEl.textContent = String(mk); if (markupRow) markupRow.hidden = !(mk > 0); }
      if (trustShip) trustShip.hidden = !(n.price >= fsMin);
      var shipOver = $('[data-zd-ship-over]'); if (shipOver) shipOver.hidden = n.price >= fsMin;
      // round 9: fixed refill per tier (two-tier draft): text follows the tier, the Seal plan with the same number of months is used
      var rTxt = $('[data-zd-refill-txt]'), rd2 = t.getAttribute('data-refill') || '';
      if (rTxt && rd2) rTxt.textContent = rd2.replace(/^every\s+/i, '');
      if (rTxt && sub && sub.getAttribute('data-plans')) { var pid = planFor(rd2); if (pid) { sub.setAttribute('data-plan', pid); if (pI && n.plan) pI.value = pid; } }
      var shipWord = $('[data-zd-shipword]'); // round 9: "Fast & Free Delivery" only when this selection ships free
      if (shipWord) shipWord.textContent = shipWord.getAttribute(n.price >= fsMin ? 'data-free' : 'data-paid');
      if (oncePrice) oncePrice.textContent = money(+t.getAttribute('data-once'), fmt);
      if (onceBtn) { onceBtn.classList.toggle('is-on', !subOn()); onceBtn.setAttribute('aria-pressed', subOn() ? 'false' : 'true'); }
      // "Free shipping on every refill" only when the refill itself clears the free-shipping minimum (fallback mode always).
      if (shipPerk && root.getAttribute('data-mode') !== 'fallback') { var sp2 = t.getAttribute('data-sub'); shipPerk.hidden = !(sp2 !== '' && +sp2 >= fsMin); if (subT) subT.textContent = subT.getAttribute(shipPerk.hidden ? 'data-t-short' : 'data-t-full'); }
      if (stitle) stitle.textContent = t.getAttribute('data-title');
      if (badge) { var l = t.getAttribute('data-label'); if (l) { badge.textContent = l; badge.hidden = false; } else badge.hidden = true; }
      var g = +t.getAttribute('data-gifts') || 0;
      $$('[data-zd-gift]').forEach(function (el) { var u = +el.getAttribute('data-zd-gift'); el.classList.toggle('is-on', u > 0 && u <= g); });
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        tiers.forEach(function (o) { o.classList.remove('is-on'); });
        t.classList.add('is-on');
        state();
      });
    });
    function setSub(on) {
      if (!sub) return;
      sub.classList.toggle('is-on', on);
      sub.querySelector('input').checked = on;
      state();
    }
    if (sub) sub.addEventListener('click', function (e) {
      if (e.target.closest('[data-zd-freq], select[data-zd-refill], [data-zd-refill] [data-value]')) return; // the frequency dropdown / pills
      e.preventDefault();
      setSub(sub.hasAttribute('data-zd-radio') ? true : !sub.classList.contains('is-on'));
    });
    // keyboard: the (visually hidden) checkbox inside the Auto-Refill card
    var subIn = sub && sub.querySelector('input');
    if (subIn && sub.hasAttribute('data-zd-radio')) subIn.addEventListener('change', function () { setSub(true); });
    refillPills.forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); refillSel.__zdTouched = true; pickRefill(b.getAttribute('data-value')); setSub(true); });
    });
    if (onceBtn) onceBtn.addEventListener('click', function () { setSub(false); });
    if (refillSel) refillSel.addEventListener('change', function () { refillSel.__zdTouched = true; });
    if (freqSel) freqSel.addEventListener('change', function () { sub.setAttribute('data-plan', freqSel.value); state(); });
    // ?tier=N (1-based) preselects tier N (the advertorial links with ?tier=2).
    var want = parseInt(params.get('tier'), 10);
    if (want >= 1 && want <= tiers.length) {
      tiers.forEach(function (o) { o.classList.remove('is-on'); });
      tiers[want - 1].classList.add('is-on');
    }
    state();

    /* add to cart (AJAX through the zd cart drawer; native post if it is missing) */
    var atc = $('[data-zd-atc]'), err = $('[data-zd-err]');
    function selection() {
      var t = selected(), n = numbers(t);
      var item = { id: +t.getAttribute('data-variant'), quantity: +t.getAttribute('data-qty') };
      var plan = n.plan && sub && sub.getAttribute('data-plan');
      if (plan) item.selling_plan = +plan;
      // The free gifts this tier unlocks in the gift ladder travel with the line (hidden "_" property), so the
      // cart drawer shows the same gifts as unlocked instead of "You're $X away" (08-02).
      var gifts = +t.getAttribute('data-gifts') || 0;
      if (gifts > 0) item.properties = { _zd_gifts: String(gifts) };
      if (gifts >= 2) item.properties['_Free gift'] = 'Mystery gift'; // round 9j: shows on the order for packing
      // Round 8: the tier name ("6 Rolls") rides along so the cart line says what the buy box said, not only the
      // Shopify variant name ("Buy 2 Get 4 Free").
      var tierName = t.getAttribute('data-title');
      if (tierName && document.querySelectorAll('[data-zd-tier]').length > 1) { item.properties = item.properties || {}; item.properties._zd_tier = tierName; }
      return item;
    }
    function add(btn) {
      if (!window.ZDCart) { if (form) form.submit(); return Promise.resolve(); }
      if (err) err.hidden = true;
      var b = btn || atc;
      if (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
      var it = selection();
      return window.ZDCart.add([it], b).then(function (j) {
        // Round 9j (Mando: Auto-Refill ticked, cart line came in one-time): if anything between the page and the cart
        // (an app script, a stale form) dropped the selling plan, put it back on the line before the shopper sees the cart.
        if (!it.selling_plan || !j || !j.items) return j;
        var miss = j.items.filter(function (l) { return l.variant_id === it.id && !l.selling_plan_allocation; });
        return miss.reduce(function (p, l) { return p.then(function () { return window.ZDCart.change({ id: l.key, quantity: l.quantity, selling_plan: it.selling_plan }); }); }, Promise.resolve()).then(function () { return j; });
      }).catch(function (e) {
        if (err) { err.textContent = (e && e.message) || 'Could not add to cart. Please try again.'; err.hidden = false; }
      }).then(function () {
        if (b) { b.disabled = false; b.removeAttribute('aria-busy'); }
      });
    }
    if (form) form.addEventListener('submit', function (e) {
      if (!window.ZDCart) return; // native post
      e.preventDefault();
      add(atc);
    });

    /* sticky bar: shows once the main button has scrolled above the viewport */
    var st = $('[data-zd-sticky]'), stAdd = $('[data-zd-sticky-add]');
    if (stAdd) stAdd.addEventListener('click', function () { add(stAdd); });
    // Round 4: the button can jump from below the screen to above it in one scroll (anchor links, fast flicks) without
    // ever intersecting, so a passive scroll check backs up the IntersectionObserver.
    function stickyState(past) {
      if (st.classList.contains('is-on') === past) return;
      st.classList.toggle('is-on', past);
      document.documentElement.classList.toggle('zd-sticky-on', past);
      st.setAttribute('aria-hidden', past ? 'false' : 'true');
      if (stAdd) stAdd.tabIndex = past ? 0 : -1;
    }
    if (st && atc) {
      var stTick = false;
      window.addEventListener('scroll', function () {
        if (stTick) return;
        stTick = true;
        requestAnimationFrame(function () { stTick = false; stickyState(atc.getBoundingClientRect().bottom < 0); });
      }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          stickyState(!e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(atc);
      }
    }

    /* rating -> reviews */
    var rating = $('[data-zd-rating]');
    if (rating) rating.addEventListener('click', function (e) {
      var target = document.getElementById('zd-reviews') || document.getElementById('looxReviews');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    /* round 9: a session countdown that shares "Complete the routine"'s clock (same sessionStorage start, same reset) */
    $$('[data-zd-session-clock]').forEach(function (el) {
      var span = (+el.getAttribute('data-min') || 10) * 60000, k = 'zd_routine_t0';
      var get = function () { var v = 0; try { v = +sessionStorage.getItem(k) || 0; } catch (e) {} return v; };
      var tick = function () {
        var t0 = get(); if (!t0 || Date.now() - t0 > span) { t0 = Date.now(); try { sessionStorage.setItem(k, String(t0)); } catch (e) {} }
        var s = Math.ceil((span - (Date.now() - t0)) / 1000); el.textContent = Math.floor(s / 60) + ':' + ('0' + s % 60).slice(-2);
      };
      tick(); setInterval(tick, 1000);
    });

    /* delivery date range */
    $$('[data-zd-deliv]').forEach(function (d) {
      var o = d.getAttribute('data-fmt') === 'short' ? { month: 'short', day: 'numeric' } : { weekday: 'short', month: 'short', day: 'numeric' }, a = new Date(), b = new Date();
      a.setDate(a.getDate() + (+d.getAttribute('data-min') || 3));
      b.setDate(b.getDate() + (+d.getAttribute('data-max') || 6));
      d.querySelector('[data-zd-dates]').textContent = a.toLocaleDateString('en-US', o) + ' – ' + b.toLocaleDateString('en-US', o);
    });

    /* offer countdown: rolling 2-hour by default, weekly via data-zd-timer (theme setting); same clock as the bar */
    var c = $('[data-zd-count]');
    function mountCount() { if (!window.ZDCountdown) return setTimeout(mountCount, 40); if (!c.hasAttribute('data-zd-end')) window.ZDCountdown.mount(c); }
    if (c) mountCount();

    /* "Complete your routine": once a card's product is in the cart, hide the card (no duplicates) */
    var up = $('[data-zd-upsell]');
    if (up) {
      document.addEventListener('zd:cart:added', function (e) {
        var items = (e.detail && e.detail.items) || [];
        items.forEach(function (i) {
          var btn = up.querySelector('[data-zd-quick-add][data-variant="' + i.id + '"]');
          var card = btn && btn.closest('[data-zd-qa-card]');
          if (card) card.hidden = true;
        });
        up.hidden = !up.querySelector('[data-zd-qa-card]:not([hidden])');
      });
    }

    root.ZD = { state: state, add: add, selection: selection };
  }

  function boot() {
    revealMerchant();
    document.querySelectorAll('[data-zd-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
